export function generateOfflinePage(appName: string): string {
  return `<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>${appName} | Offline</title>
    <style>
      :root {
        color-scheme: light;
        --bg: #f8fafc;
        --surface: #ffffff;
        --text: #0f172a;
        --muted: #475569;
        --accent: #0f172a;
      }
      * { box-sizing: border-box; }
      body {
        margin: 0;
        min-height: 100vh;
        display: grid;
        place-items: center;
        padding: 24px;
        font-family: system-ui, sans-serif;
        background:
          radial-gradient(circle at top left, rgba(15, 23, 42, 0.08), transparent 30%),
          linear-gradient(180deg, #ffffff, var(--bg));
        color: var(--text);
      }
      .card {
        width: min(100%, 620px);
        background: var(--surface);
        border-radius: 24px;
        padding: 32px;
        box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
      }
      h1 { margin: 0 0 12px; font-size: clamp(2rem, 4vw, 3rem); }
      p { margin: 0 0 16px; line-height: 1.6; color: var(--muted); }
      .pill {
        display: inline-flex;
        align-items: center;
        border-radius: 999px;
        padding: 8px 12px;
        background: rgba(15, 23, 42, 0.06);
        color: var(--accent);
        font-weight: 600;
        font-size: 0.9rem;
      }
    </style>
  </head>
  <body>
    <main class="card">
      <div class="pill">Offline mode</div>
      <h1>You are offline</h1>
      <p>${appName} cannot reach the network right now, but go-offline is keeping the experience resilient.</p>
      <p>Try reconnecting and refresh when you are back online.</p>
    </main>
  </body>
</html>
`;
}
